/* BHALLO — produtos vistos recentemente (localStorage) */
(function () {
  var KEY = 'bhallo:recent';
  var MAX = 8;

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      return raw ? JSON.parse(raw) : [];
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',');
  }

  function esc(s) {
    var d = document.createElement('div');
    d.textContent = s == null ? '' : s;
    return d.innerHTML;
  }

  function saveCurrent() {
    var tag = document.getElementById('BhalloRecentCurrent');
    if (!tag) return null;
    var cur;
    try {
      cur = JSON.parse(tag.textContent);
    } catch (e) {
      return null;
    }
    if (!cur || !cur.handle) return null;

    var list = read().filter(function (p) {
      return p.handle !== cur.handle;
    });
    list.unshift(cur);
    write(list.slice(0, MAX));
    return cur.handle;
  }

  function render(currentHandle) {
    var box = document.getElementById('BhalloRecent');
    var grid = document.getElementById('BhalloRecentGrid');
    if (!box || !grid) return;

    var list = read().filter(function (p) {
      return p.handle && p.handle !== currentHandle;
    });
    if (!list.length) return;

    grid.innerHTML = list
      .slice(0, 5)
      .map(function (p) {
        var img = p.image
          ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">'
          : '';
        return (
          '<a class="bhallo-recent__card" href="' + esc(p.url) + '">' +
          '<span class="bhallo-recent__media">' + img + '</span>' +
          '<span class="bhallo-recent__name">' + esc(p.title) + '</span>' +
          '<span class="bhallo-recent__price">' + money(p.price) + '</span>' +
          '</a>'
        );
      })
      .join('');

    box.hidden = false;
  }

  function init() {
    var handle = saveCurrent();
    render(handle);
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
